// import axios from "axios";
// import React, { useEffect, useState, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import { Spinner } from "react-bootstrap";
// import { toast } from "react-toastify";
// import avatar from "../../../../../assets/images/avatarr.png";
// import phone from "../../../../../assets/images/phone.png";
// import { switchEndpoint } from "../../../../../redux/actions/endpoints";
// import DriversNavigation from "../../components/Navbar/navbar";
// import MixedModal from "../modals/mixed";
// import SortedeModal from "../modals/sorted";
// import UnsortedeModal from "../modals/unsorted";
// import SingleColorModal from "../modals/singleColor";
// import PureWaterModal from "../modals/pureWater";
// import HdpeModal from "../modals/hdpe";
// import HardPackagingModal from "../modals/hardPackaging";
// import PPModal from "../modals/pp";
// import PackagingBagModal from "../modals/packagingBag";
// import CansModal from "../modals/cansModal";
// import { getPricing } from "../../../../../pricingMethod";
// import BottlePreformModal from "../modals/bottlePreform";
// import TinCanmModal from "../modals/tinCans";

// const categories = [
//   "Clean Sorted",
//   "Clean Unsorted",
//   "Pure Water Nylon",
//   "Single color caps",
//   "Hard packing bags (dry)",
//   "Mixed Plastics",
//   "HDPE plastics below 5 Litres",
//   "PP Plastics",
//   "Pure Water Packaging Bags",
//   "Bottle Preform",
//   "Aluminum Cans",
//   "Tin Cans",
// ];

// const CalculateTransaction = (props) => {
//   const [pricingList, setPricingList] = useState([]);
//   const payment = JSON.parse(localStorage.getItem("pay"));

//   const getAllPricing = () => {
//     const token = storage.getItem("token");
//     axios
//       .get(`${switchEndpoint}/all-waste-categories`, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((response) => {
//         setPricingList(response.data);
//       })
//       .catch((error) => {
//         toast.error(error.response.data.message, {
//           position: "top-right",
//           autoClose: 5000,
//           hideProgressBar: false,
//           pauseOnHover: true,
//           progress: undefined,
//           theme: "light",
//         });
//       });
//   };

//   useEffect(() => {
//     getAllPricing();
//   }, []);
//   const location = useLocation();
//   // console.log(location);
//   let pricing = location?.state?.pricingObject;
//   const [selectedMethod, setSelectedMethod] = useState("");
//   const initiateDetails = JSON.parse(localStorage.getItem("initiate"));
//   const [loading, setLoading] = useState(0);

//   const [cleanSortedKg, setCleanSortedKg] = useState("");
//   const [cleanSortedAmount, setCleanSortedAmount] = useState(null);
//   const [cleanSortedDeduction, setCleanSortedDeduction] = useState("");

//   const [cleanUnsortedKg, setCleanUnsortedKg] = useState("");
//   const [cleanUnsortedAmount, setCleanUnsortedAmount] = useState(null);
//   const [cleanUnsortedDeduction, setCleanUnsortedDeduction] = useState("");

//   const [mixedPlasticsKg, setMixedPlasticsKg] = useState("");
//   const [mixedPlasticsAmount, setMixedPlasticsAmount] = useState(null);
//   const [mixedPlasticsDeduction, setMixedPlasticsDeduction] = useState("");

//   const [pureWaterKg, setPureWaterKg] = useState("");
//   const [pureWaterAmount, setPureWaterAmount] = useState(null);
//   const [pureWaterDeduction, setPureWaterDeduction] = useState("");

//   const [singleColorKg, setSingleColorKg] = useState("");
//   const [singleColorAmount, setSingleColorAmount] = useState(null);
//   const [singleColorDeduction, setSingleColorDeduction] = useState("");

//   const [hardPackagingKg, setHardPackagingKg] = useState("");
//   const [hardPackagingAmount, setHardPackagingAmount] = useState(null);
//   const [hardPackagingDeduction, setHardPackagingDeduction] = useState("");

//   const [hdpeKg, setHdpeKg] = useState("");
//   const [hdpeAmount, setHdpeAmount] = useState(null);
//   const [hdpeDeduction, setHdpeDeduction] = useState("");

//   const [ppKg, setPpKg] = useState("");
//   const [ppAmount, setPpAmount] = useState(null);
//   const [ppDeduction, setPpDeduction] = useState("");

//   const [packagingBagKg, setPackagingBagKg] = useState("");
//   const [packagingBagAmount, setPackagingBagAmount] = useState(null);
//   const [packagingBagDeduction, setPackagingBagDeduction] = useState("");

//   const [cansKg, setCansKg] = useState("");
//   const [cansAmount, setCansAmount] = useState(null);
//   const [cansDeduction, setCansDeduction] = useState("");

//   const [bottlePreformKg, setBottlePreformKg] = useState("");
//   const [bottlePreformAmount, setBottlePreformAmount] = useState(null);
//   const [bottlePreformDeduction, setBottlePreformDeduction] = useState("");

//   const [tinCansKg, setTinCansKg] = useState("");
//   const [tinCansAmount, setTinCansAmount] = useState(null);
//   const [tinCansDeduction, setTinCansDeduction] = useState("");

//   const calculateSortedVal = (val) => {
//     if (cleanSortedDeduction !== "") {
//       let price =
//         getPricing(pricingList, "clean_sorted", cleanSortedKg, "pickup") *
//         cleanSortedKg;
//       const ded = val / 100;
//       const df = ded * cleanSortedAmount;
//       setDeduction1Val(df);
//       setCleanSortedAmount(price - df);
//       // console.log(price);
//     } else {
//       let price =
//         getPricing(pricingList, "clean_sorted", cleanSortedKg, "pickup") *
//         cleanSortedKg;
//       const ded = 0 / 100;
//       const df = ded * cleanSortedAmount;
//       setDeduction1Val(df);
//       setCleanSortedAmount(price - df);
//     }
//   };

//   useEffect(() => {
//     calculateSortedVal(cleanSortedDeduction);
//   }, [cleanSortedDeduction]);

//   const calculateUnsortedVal = (val) => {
//     if (cleanUnsortedDeduction !== "") {
//       let price =
//         getPricing(pricingList, "clean_unsorted", cleanUnsortedKg, "pickup") *
//         cleanUnsortedKg;
//       console.log(price);
//       const ded = val / 100;
//       const df = ded * cleanUnsortedAmount;
//       setDeduction2Val(df);
//       setCleanUnsortedAmount(price - df);
//     } else {
//       let price =
//         getPricing(pricingList, "clean_unsorted", cleanUnsortedKg, "pickup") *
//         cleanUnsortedKg;
//       const ded = 0 / 100;
//       const df = ded * cleanUnsortedAmount;
//       setDeduction2Val(df);
//       setCleanUnsortedAmount(price - df);
//     }
//   };

//   useEffect(() => {
//     calculateUnsortedVal(cleanUnsortedDeduction);
//   }, [cleanUnsortedDeduction]);

//   const calculateMixedPlasticsVal = (val) => {
//     if (mixedPlasticsDeduction !== "") {
//       let price =
//         getPricing(pricingList, "mixed_plastics", mixedPlasticsKg, "pickup") *
//         mixedPlasticsKg;
//       const ded = val / 100;
//       const df = ded * mixedPlasticsAmount;
//       setDeduction3Val(df);
//       setMixedPlasticsAmount(price - df);
//     } else {
//       let price =
//         getPricing(pricingList, "mixed_plastics", mixedPlasticsKg, "pickup") *
//         mixedPlasticsKg;
//       const ded = 0 / 100;
//       const df = ded * mixedPlasticsAmount;
//       setDeduction3Val(df);
//       setMixedPlasticsAmount(price - df);
//     }
//   };

//   useEffect(() => {
//     calculateMixedPlasticsVal(mixedPlasticsDeduction);
//   }, [mixedPlasticsDeduction]);

//   const pureWaterVal = (val) => {
//     if (pureWaterDeduction !== "") {
//       let price =
//         getPricing(
//           pricingList,
//           "pure_water_sachet_dry",
//           pureWaterKg,
//           "pickup"
//         ) * pureWaterKg;
//       const ded = val / 100;
//       const df = ded * pureWaterAmount;
//       setDeduction4Val(df);
//       setPureWaterAmount(price - df);
//     } else {
//       let price =
//         getPricing(
//           pricingList,
//           "pure_water_sachet_dry",
//           pureWaterKg,
//           "pickup"
//         ) * pureWaterKg;
//       const ded = 0 / 100;
//       const df = ded * pureWaterAmount;
//       setDeduction4Val(df);
//       setPureWaterAmount(price - df);
//     }
//   };

//   useEffect(() => {
//     pureWaterVal(pureWaterDeduction);
//   }, [pureWaterDeduction]);

//   const singleColorVal = (val) => {
//     if (singleColorDeduction !== "") {
//       let price =
//         getPricing(pricingList, "single_colour_caps", singleColorKg, "pickup") *
//         singleColorKg;
//       const ded = val / 100;
//       const df = ded * singleColorAmount;
//       setDeduction5Val(df);
//       setSingleColorAmount(price - df);
//     } else {
//       let price =
//         getPricing(pricingList, "single_colour_caps", singleColorKg, "pickup") *
//         singleColorKg;
//       const ded = 0 / 100;
//       const df = ded * singleColorAmount;
//       setDeduction5Val(df);
//       setSingleColorAmount(price - df);
//     }
//   };

//   useEffect(() => {
//     singleColorVal(singleColorDeduction);
//   }, [singleColorDeduction]);

//   const hardPackagingVal = (val) => {
//     if (hardPackagingDeduction !== "") {
//       let price =
//         getPricing(
//           pricingList,
//           "hard_packing_bags_dry",
//           hardPackagingKg,
//           "pickup"
//         ) * hardPackagingKg;
//       const ded = val / 100;
//       const df = ded * hardPackagingAmount;
//       setDeduction6Val(df);
//       setHardPackagingAmount(price - df);
//     } else {
//       let price =
//         getPricing(
//           pricingList,
//           "hard_packing_bags_dry",
//           hardPackagingKg,
//           "pickup"
//         ) * hardPackagingKg;
//       const ded = 0 / 100;
//       const df = ded * hardPackagingAmount;
//       setDeduction6Val(df);
//       setHardPackagingAmount(price - df);
//     }
//   };

//   useEffect(() => {
//     hardPackagingVal(hardPackagingDeduction);
//   }, [hardPackagingDeduction]);

//   const hdpeVal = (val) => {
//     if (hdpeDeduction !== "") {
//       let price =
//         getPricing(
//           pricingList,
//           "hdpe_plastics_below_five_meters",
//           hdpeKg,
//           "pickup"
//         ) * hdpeKg;
//       const ded = val / 100;
//       const df = ded * hdpeAmount;
//       setDeduction7Val(df);
//       setHdpeAmount(price - df);
//     } else {
//       let price =
//         getPricing(
//           pricingList,
//           "hdpe_plastics_below_five_meters",
//           hdpeKg,
//           "pickup"
//         ) * hdpeKg;
//       const ded = 0 / 100;
//       const df = ded * hdpeAmount;
//       setDeduction7Val(df);
//       setHdpeAmount(price - df);
//     }
//   };

//   useEffect(() => {
//     hdpeVal(hdpeDeduction);
//   }, [hdpeDeduction]);

//   const ppVal = (val) => {
//     if (ppDeduction !== "") {
//       let price = getPricing(pricingList, "pp_plastics", ppKg, "pickup") * ppKg;
//       const ded = val / 100;
//       const df = ded * ppAmount;
//       setDeduction8Val(df);
//       setPpAmount(price - df);
//     } else {
//       let price = getPricing(pricingList, "pp_plastics", ppKg, "pickup") * ppKg;
//       const ded = 0 / 100;
//       const df = ded * ppAmount;
//       setDeduction8Val(df);
//       setPpAmount(price - df);
//     }
//   };

//   useEffect(() => {
//     ppVal(ppDeduction);
//   }, [ppDeduction]);

//   const packagingBagVal = (val) => {
//     if (packagingBagDeduction !== "") {
//       let price =
//         getPricing(pricingList, "packing_bags", packagingBagKg, "pickup") *
//         packagingBagKg;
//       const ded = val / 100;
//       const df = ded * packagingBagAmount;
//       setDeduction9Val(df);
//       setPackagingBagAmount(price - df);
//     } else {
//       let price =
//         getPricing(pricingList, "packing_bags", packagingBagKg, "pickup") *
//         packagingBagKg;
//       const ded = 0 / 100;
//       const df = ded * packagingBagAmount;
//       setDeduction9Val(df);
//       setPackagingBagAmount(price - df);
//     }
//   };

//   useEffect(() => {
//     packagingBagVal(packagingBagDeduction);
//   }, [packagingBagDeduction]);

//   const cansVal = (val) => {
//     if (cansDeduction !== "") {
//       let price =
//         getPricing(pricingList, "aluminum_cans", cansKg, "pickup") * cansKg;
//       const ded = val / 100;
//       const df = ded * cansAmount;
//       setDeduction10Val(df);
//       setCansAmount(price - df);
//     } else {
//       let price =
//         getPricing(pricingList, "aluminum_cans", cansKg, "pickup") * cansKg;
//       const ded = 0 / 100;
//       const df = ded * cansAmount;
//       setDeduction10Val(df);
//       setCansAmount(price - df);
//     }
//   };

//   useEffect(() => {
//     cansVal(cansDeduction);
//   }, [cansDeduction]);

//   const bottlePreformVal = (val) => {
//     if (bottlePreformDeduction !== "") {
//       let price =
//         getPricing(pricingList, "bottle_preform", bottlePreformKg, "pickup") *
//         bottlePreformKg;
//       const ded = val / 100;
//       const df = ded * bottlePreformAmount;
//       setDeduction11Val(df);
//       setBottlePreformAmount(price - df);
//     } else {
//       let price =
//         getPricing(pricingList, "bottle_preform", bottlePreformKg, "pickup") *
//         bottlePreformKg;
//       const ded = 0 / 100;
//       const df = ded * bottlePreformAmount;
//       setDeduction11Val(df);
//       setBottlePreformAmount(price - df);
//     }
//   };

//   useEffect(() => {
//     bottlePreformVal(bottlePreformDeduction);
//   }, [bottlePreformDeduction]);

//   const tinVal = (val) => {
//     if (tinCansDeduction !== "") {
//       let price =
//         getPricing(pricingList, "tin_can", tinCansKg, "pickup") * tinCansKg;
//       const ded = val / 100;
//       const df = ded * tinCansAmount;
//       setDeduction12Val(df);
//       setTinCansAmount(price - df);
//     } else {
//       let price =
//         getPricing(pricingList, "tin_can", tinCansKg, "pickup") * tinCansKg;
//       const ded = 0 / 100;
//       const df = ded * tinCansAmount;
//       setDeduction12Val(df);
//       setTinCansAmount(price - df);
//     }
//   };

//   useEffect(() => {
//     tinVal(tinCansDeduction);
//   }, [tinCansDeduction]);

//   // console.log(cleanSortedKg);

//   useEffect(() => {
//     setCleanSortedAmount(
//       getPricing(pricingList, "clean_sorted", cleanSortedKg, "pickup") *
//         cleanSortedKg
//     );
//   }, [cleanSortedKg]);

//   useEffect(() => {
//     setCleanUnsortedAmount(
//       getPricing(pricingList, "clean_unsorted", cleanUnsortedKg, "pickup") *
//         cleanUnsortedKg
//     );
//   }, [cleanUnsortedKg]);

//   useEffect(() => {
//     setMixedPlasticsAmount(
//       getPricing(pricingList, "mixed_plastics", mixedPlasticsKg, "pickup") *
//         mixedPlasticsKg
//     );
//   }, [mixedPlasticsKg]);

//   useEffect(() => {
//     setPureWaterAmount(
//       getPricing(pricingList, "pure_water_sachet_dry", pureWaterKg, "pickup") *
//         pureWaterKg
//     );
//   }, [pureWaterKg]);

//   useEffect(() => {
//     setSingleColorAmount(
//       getPricing(pricingList, "single_colour_caps", singleColorKg, "pickup") *
//         singleColorKg
//     );
//   }, [singleColorKg]);

//   useEffect(() => {
//     setHardPackagingAmount(
//       getPricing(
//         pricingList,
//         "hard_packing_bags_dry",
//         hardPackagingKg,
//         "pickup"
//       ) * hardPackagingKg
//     );
//   }, [hardPackagingKg]);

//   useEffect(() => {
//     setHdpeAmount(
//       getPricing(
//         pricingList,
//         "hdpe_plastics_below_five_meters",
//         hdpeKg,
//         "pickup"
//       ) * hdpeKg
//     );
//   }, [hdpeKg]);

//   useEffect(() => {
//     setPpAmount(getPricing(pricingList, "pp_plastics", ppKg, "pickup") * ppKg);
//   }, [ppKg]);

//   useEffect(() => {
//     setPackagingBagAmount(
//       getPricing(pricingList, "packing_bags", packagingBagKg, "pickup") *
//         packagingBagKg
//     );
//   }, [packagingBagKg]);

//   useEffect(() => {
//     setCansAmount(
//       getPricing(pricingList, "aluminum_cans", cansKg, "pickup") * cansKg
//     );
//   }, [cansKg]);

//   useEffect(() => {
//     setBottlePreformAmount(
//       getPricing(pricingList, "bottle_preform", bottlePreformKg, "pickup") *
//         bottlePreformKg
//     );
//   }, [bottlePreformKg]);

//   useEffect(() => {
//     setTinCansAmount(
//       getPricing(pricingList, "tin_can", tinCansKg, "pickup") * tinCansKg
//     );
//   }, [tinCansKg]);

//   const handleInputChangeCS = (event) => {
//     const { value } = event.target;
//     // Allow the field to be cleared or match the specific pattern
//     if (value === "" || /^(0|([1-9][0-9]*))(\.\d{0,2})?$/.test(value)) {
//       setCleanSortedDeduction(value);
//     }
//   };

//   const handleInputChangeCU = (event) => {
//     const { value } = event.target;
//     // Allow the field to be cleared or match the specific pattern
//     if (value === "" || /^(0|([1-9][0-9]*))(\.\d{0,2})?$/.test(value)) {
//       setCleanUnsortedDeduction(value);
//     }
//   };

//   const handleInputChangeMx = (event) => {
//     const { value } = event.target;
//     // Allow the field to be cleared or match the specific pattern
//     if (value === "" || /^(0|([1-9][0-9]*))(\.\d{0,2})?$/.test(value)) {
//       setMixedPlasticsDeduction(value);
//     }
//   };

//   const handleInputChangePw = (event) => {
//     const { value } = event.target;
//     // Allow the field to be cleared or match the specific pattern
//     if (value === "" || /^(0|([1-9][0-9]*))(\.\d{0,2})?$/.test(value)) {
//       setPureWaterDeduction(value);
//     }
//   };

//   const handleInputChangeSC = (event) => {
//     const { value } = event.target;
//     // Allow the field to be cleared or match the specific pattern
//     if (value === "" || /^(0|([1-9][0-9]*))(\.\d{0,2})?$/.test(value)) {
//       setSingleColorDeduction(value);
//     }
//   };

//   const handleInputChangeHP = (event) => {
//     const { value } = event.target;
//     // Allow the field to be cleared or match the specific pattern
//     if (value === "" || /^(0|([1-9][0-9]*))(\.\d{0,2})?$/.test(value)) {
//       setHardPackagingDeduction(value);
//     }
//   };

//   const handleInputChangeHD = (event) => {
//     const { value } = event.target;
//     // Allow the field to be cleared or match the specific pattern
//     if (value === "" || /^(0|([1-9][0-9]*))(\.\d{0,2})?$/.test(value)) {
//       setHdpeDeduction(value);
//     }
//   };

//   const handleInputChangePP = (event) => {
//     const { value } = event.target;
//     // Allow the field to be cleared or match the specific pattern
//     if (value === "" || /^(0|([1-9][0-9]*))(\.\d{0,2})?$/.test(value)) {
//       setPpDeduction(value);
//     }
//   };

//   const handleInputChangePB = (event) => {
//     const { value } = event.target;
//     // Allow the field to be cleared or match the specific pattern
//     if (value === "" || /^(0|([1-9][0-9]*))(\.\d{0,2})?$/.test(value)) {
//       setPackagingBagDeduction(value);
//     }
//   };

//   const handleInputChangeCans = (event) => {
//     const { value } = event.target;
//     // Allow the field to be cleared or match the specific pattern
//     if (value === "" || /^(0|([1-9][0-9]*))(\.\d{0,2})?$/.test(value)) {
//       setCansDeduction(value);
//     }
//   };

//   const handleInputChangeTinCan = (event) => {
//     const { value } = event.target;
//     // Allow the field to be cleared or match the specific pattern
//     if (value === "" || /^(0|([1-9][0-9]*))(\.\d{0,2})?$/.test(value)) {
//       setTinCansDeduction(value);
//     }
//   };

//   const handleInputChangeBottlePreform = (event) => {
//     const { value } = event.target;
//     // Allow the field to be cleared or match the specific pattern
//     if (value === "" || /^(0|([1-9][0-9]*))(\.\d{0,2})?$/.test(value)) {
//       setBottlePreformDeduction(value);
//     }
//   };

//   const [form, setForm] = useState({
//     sorted: "",
//     unsorted: "",
//     mixed: "",
//     pureWater: "",
//     singleColor: "",
//     hardPackaging: "",
//     hdpe: "",
//     pp: "",
//     packagingBag: "",
//     cans: "",
//     bottle_preform: "",
//     tin_cans: "",
//     deductSorted: "",
//     deductUnsorted: "",
//     deductMixed: "",
//     deductSinglePureWater: "",
//     deductSingleColor: "",
//     deductHardPackaging: "",
//     deductHdpe: "",
//     deductPp: "",
//     deductPackagingBag: "",
//     deductCans: "",
//     deductTinCans: "",
//     deductBottlePreform: "",
//   });

//   const handleFormChange =
//     (name) =>
//     ({ target }) => {
//       if (/^(\d*(\.\d{0,2})?)?$/.test(target.value)) {
//         setForm({
//           ...form,
//           [name]: target.value,
//         });
//       }
//     };

//   const [showSorted, setShowSorted] = useState(false);
//   const handleCloseSorted = () => setShowSorted(false);
//   const handleShowSorted = () => setShowSorted(true);

//   const [showUnsorted, setShowUnsorted] = useState(false);
//   const handleCloseUnsorted = () => setShowUnsorted(false);
//   const handleShowUnsorted = () => setShowUnsorted(true);

//   const [showMixed, setShowMixed] = useState(false);
//   const handleCloseMixed = () => setShowMixed(false);
//   const handleShowMixed = () => setShowMixed(true);

//   const [showPureWater, setShowPureWater] = useState(false);
//   const handleClosePureWater = () => setShowPureWater(false);
//   const handleShowPureWater = () => setShowPureWater(true);

//   const [showSingleColor, setShowSingleColor] = useState(false);
//   const handleCloseSingleColor = () => setShowSingleColor(false);
//   const handleShowSingleColor = () => setShowSingleColor(true);

//   const [showHardPackaging, setShowHardPackaging] = useState(false);
//   const handleCloseHardPackaging = () => setShowHardPackaging(false);
//   const handleShowHardPackaging = () => setShowHardPackaging(true);

//   const [showhdpe, setShowhdpe] = useState(false);
//   const handleClosehdpe = () => setShowhdpe(false);
//   const handleShowhdpe = () => setShowhdpe(true);

//   const [showPp, setShowPp] = useState(false);
//   const handleClosePp = () => setShowPp(false);
//   const handleShowPp = () => setShowPp(true);

//   const [showPackagingBag, setShowPackagingBag] = useState(false);
//   const handleClosePackagingBag = () => setShowPackagingBag(false);
//   const handleShowPackagingBag = () => setShowPackagingBag(true);

//   const [showCans, setShowCans] = useState(false);
//   const handleCloseCans = () => setShowCans(false);
//   const handleShowCans = () => setShowCans(true);

//   const [showTinCans, setShowTinCans] = useState(false);
//   const handleCloseTinCans = () => setShowTinCans(false);
//   const handleShowTinCans = () => setShowTinCans(true);

//   const [showBottlePreform, setShowBottlePreform] = useState(false);
//   const handleCloseBottlePreform = () => setShowBottlePreform(false);
//   const handleShowBottlePreform = () => setShowBottlePreform(true);

//   const [sortedValue, setSortedValue] = useState(0);
//   const [unsortedValue, setUnsortedValue] = useState(0);
//   const [mixedValue, setMixedValue] = useState(0);
//   const [pureWaterValue, setPureWaterValue] = useState(0);
//   const [singleColorValue, setSingleColorValue] = useState(0);
//   const [hardPackagingValue, setHardPackagingValue] = useState(0);
//   const [hdpeValue, setHdpeValue] = useState(0);
//   const [ppValue, setPpValue] = useState(0);
//   const [packagingBagValue, setPackagingBagValue] = useState(0);
//   const [cansValue, setCansValue] = useState(0);
//   const [tinCansValue, setTinCansValue] = useState(0);
//   const [bottlePreformValue, setBottlePreformValue] = useState(0);
//   const [finalValue, setFinalValue] = useState(0);
//   const [deduction1Val, setDeduction1Val] = useState(0);
//   const [deduction2Val, setDeduction2Val] = useState(0);
//   const [deduction3Val, setDeduction3Val] = useState(0);
//   const [deduction4Val, setDeduction4Val] = useState(0);
//   const [deduction5Val, setDeduction5Val] = useState(0);
//   const [deduction6Val, setDeduction6Val] = useState(0);
//   const [deduction7Val, setDeduction7Val] = useState(0);
//   const [deduction8Val, setDeduction8Val] = useState(0);
//   const [deduction9Val, setDeduction9Val] = useState(0);
//   const [deduction10Val, setDeduction10Val] = useState(0);
//   const [deduction11Val, setDeduction11Val] = useState(0);
//   const [deduction12Val, setDeduction12Val] = useState(0);
//   const [totalDeduction, setTotalDeduction] = useState("");

//   // start of new implementation
//   const [selectedCategories, setSelectedCategories] = useState([]);
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const dropdownRef = useRef(null);

//   const handleCheckboxChange = (category) => {
//     setSelectedCategories((prev) =>
//       prev.includes(category)
//         ? prev.filter((c) => c !== category)
//         : [...prev, category]
//     );
//   };

//   const handleInputClick = (event) => {
//     // Prevent the click on the input from triggering the handleClickOutside event
//     event.stopPropagation();
//     setIsDropdownOpen((prev) => !prev);
//   };

//   const placeholderText = selectedCategories.length
//     ? `${selectedCategories.join(", ")}`
//     : "Select plastic categories";

//   // Click outside handler
//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsDropdownOpen(false);
//       }
//     }

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);
//   //end of new implementation

//   const final = (
//     val1,
//     val2,
//     val3,
//     val4,
//     val5,
//     val6,
//     val7,
//     val8,
//     val9,
//     val10,
//     val11,
//     val12
//   ) => {
//     const total =
//       Number(val1) +
//       Number(val2) +
//       Number(val3) +
//       Number(val4) +
//       Number(val5) +
//       Number(val6) +
//       Number(val7) +
//       Number(val8) +
//       Number(val9) +
//       Number(val10) +
//       Number(val11) +
//       Number(val12);
//     const dd = Math.round((total + Number.EPSILON) * 100) / 100;
//     setFinalValue(dd);
//   };

//   const finalDeduction = (
//     val1,
//     val2,
//     val3,
//     val4,
//     val5,
//     val6,
//     val7,
//     val8,
//     val9,
//     val10,
//     val11,
//     val12
//   ) => {
//     const total =
//       Number(val1) +
//       Number(val2) +
//       Number(val3) +
//       Number(val4) +
//       Number(val5) +
//       Number(val6) +
//       Number(val7) +
//       Number(val8) +
//       Number(val9) +
//       Number(val10) +
//       Number(val11) +
//       Number(val12);
//     const dd = Math.round((total + Number.EPSILON) * 100) / 100;
//     setTotalDeduction(dd);
//   };

//   useEffect(() => {
//     finalDeduction(
//       deduction1Val,
//       deduction2Val,
//       deduction3Val,
//       deduction4Val,
//       deduction5Val,
//       deduction6Val,
//       deduction7Val,
//       deduction8Val,
//       deduction9Val,
//       deduction10Val,
//       deduction11Val,
//       deduction12Val
//     );
//   }, [
//     deduction1Val,
//     deduction2Val,
//     deduction3Val,
//     deduction4Val,
//     deduction5Val,
//     deduction6Val,
//     deduction7Val,
//     deduction8Val,
//     deduction9Val,
//     deduction10Val,
//     deduction11Val,
//     deduction12Val,
//   ]);

//   useEffect(() => {
//     final(
//       cleanSortedAmount,
//       cleanUnsortedAmount,
//       mixedPlasticsAmount,
//       pureWaterAmount,
//       singleColorAmount,
//       hardPackagingAmount,
//       hdpeAmount,
//       ppAmount,
//       packagingBagAmount,
//       cansAmount,
//       bottlePreformAmount,
//       tinCansAmount
//     );
//   }, [
//     cleanSortedAmount,
//     cleanUnsortedAmount,
//     mixedPlasticsAmount,
//     pureWaterAmount,
//     singleColorAmount,
//     hardPackagingAmount,
//     hdpeAmount,
//     ppAmount,
//     packagingBagAmount,
//     cansAmount,
//     bottlePreformAmount,
//     tinCansAmount,
//   ]);

//   const initiatePickUp = () => {
//     if (selectedMethod === "") {
//       toast.error("Kindly select a payment method", {
//         position: "top-right",
//         autoClose: 5000,
//         hideProgressBar: false,
//         pauseOnHover: true,
//         progress: undefined,
//         theme: "light",
//       });
//       return;
//     } else {
//       setLoading(true);
//       const token = storage.getItem("token");
//       // const id = localStorage.getItem("id");
//       let waste_category = [];

//       if (cleanSortedKg) {
//         waste_category.push({
//           name: "clean_sorted",
//           kg: Number(cleanSortedKg),
//           deduction: cleanSortedDeduction ? Number(cleanSortedDeduction) : 0,
//         });
//       }

//       if (cleanUnsortedKg) {
//         waste_category.push({
//           name: "clean_unsorted",
//           kg: Number(cleanUnsortedKg),
//           deduction: cleanUnsortedDeduction
//             ? Number(cleanUnsortedDeduction)
//             : 0,
//         });
//       }

//       if (mixedPlasticsKg) {
//         waste_category.push({
//           name: "mixed_plastics",
//           kg: Number(mixedPlasticsKg),
//           deduction: mixedPlasticsDeduction
//             ? Number(mixedPlasticsDeduction)
//             : 0,
//         });
//       }

//       if (pureWaterKg) {
//         waste_category.push({
//           name: "pure_water_sachet_dry",
//           kg: Number(pureWaterKg),
//           deduction: pureWaterDeduction ? Number(pureWaterDeduction) : 0,
//         });
//       }

//       if (packagingBagKg) {
//         waste_category.push({
//           name: "packing_bags",
//           kg: Number(packagingBagKg),
//           deduction: packagingBagDeduction ? Number(packagingBagDeduction) : 0,
//         });
//       }

//       if (singleColorKg) {
//         waste_category.push({
//           name: "single_colour_caps",
//           kg: Number(singleColorKg),
//           deduction: singleColorDeduction ? Number(singleColorDeduction) : 0,
//         });
//       }

//       if (ppKg) {
//         waste_category.push({
//           name: "pp_plastics",
//           kg: Number(ppKg),
//           deduction: ppDeduction ? Number(ppDeduction) : 0,
//         });
//       }

//       if (hardPackagingKg) {
//         waste_category.push({
//           name: "hard_packing_bags_dry",
//           kg: Number(hardPackagingKg),
//           deduction: hardPackagingDeduction
//             ? Number(hardPackagingDeduction)
//             : 0,
//         });
//       }

//       if (hdpeKg) {
//         waste_category.push({
//           name: "hdpe_plastics_below_five_meters",
//           kg: Number(hdpeKg),
//           deduction: hdpeDeduction ? Number(hdpeDeduction) : 0,
//         });
//       }

//       if (cansKg) {
//         waste_category.push({
//           name: "aluminum_cans",
//           kg: Number(cansKg),
//           deduction: cansDeduction ? Number(cansDeduction) : 0,
//         });
//       }

//       if (bottlePreformKg) {
//         waste_category.push({
//           name: "bottle_preform",
//           kg: Number(bottlePreformKg),
//           deduction: bottlePreformDeduction
//             ? Number(bottlePreformDeduction)
//             : 0,
//         });
//       }

//       if (tinCansKg) {
//         waste_category.push({
//           name: "tin_can",
//           kg: Number(tinCansKg),
//           deduction: tinCansDeduction ? Number(tinCansDeduction) : 0,
//         });
//       }

//       const payload = {
//         waste_category: waste_category,
//         pickup_id: initiateDetails?.id,
//         payment_method: selectedMethod,
//         request_type: "pickup",
//       };

//       // console.log(payload)
//       axios
//         .post(`${switchEndpoint}/driver/start-pickup-transaction`, payload, {
//           headers: { Authorization: `Bearer ${token}` },
//         })
//         .then((response) => {
//           // console.log(response.data);
//           localStorage.setItem("pickUp", JSON.stringify(response.data));
//           setLoading(false);
//           props.history.push("/drivers/awaitConfirmation");
//           setForm({
//             sorted: "",
//             unsorted: "",
//             mixed: "",
//             pureWater: "",
//             singleColor: "",
//             hardPackaging: "",
//             hdpe: "",
//             pp: "",
//             cans: "",
//             bottlePreform: "",
//             tinCans: "",
//             packagingBag: "",
//             deductSorted: "",
//             deductUnsorted: "",
//             deductMixed: "",
//             deductSinglePureWater: "",
//             deductSingleColor: "",
//             deductHardPackaging: "",
//             deductHdpe: "",
//             deductPp: "",
//             deductCans: "",
//             deductBottlePreform: "",
//             deductTinCans: "",
//             deductPackagingBag: "",
//           });
//           setSortedValue(0);
//           setUnsortedValue(0);
//           setMixedValue(0);
//           setPureWaterValue(0);
//           setSingleColorValue(0);
//           setHardPackagingValue(0);
//           setHdpeValue(0);
//           setPpValue(0);
//           setPackagingBagValue(0);
//           setCansValue(0);
//           setBottlePreformValue(0);
//           setTinCansValue(0);
//         })
//         .catch((error) => {
//           toast.error(error.response.data.message, {
//             position: "top-right",
//             autoClose: 5000,
//             hideProgressBar: false,
//             pauseOnHover: true,
//             progress: undefined,
//             theme: "light",
//           });
//           setLoading(false);
//         });
//     }
//   };

//   return (
//     <div>
//       <DriversNavigation />
//       <div className="mx-3">
//         <div
//           className="d-flex align-items-center my-3"
//           style={{ width: "300px" }}
//         >
//           <img src={avatar} alt={avatar} style={{ width: "20%" }} />
//           <div>
//             <p
//               className="mb-1 ml-3"
//               style={{ fontSize: "14px", fontWeight: "400" }}
//             >
//               Household: {initiateDetails?.owner?.name}
//             </p>
//             <div className="d-flex align-items-center ml-3 mt-1">
//               <div style={{ width: "30px" }}>
//                 <img src={phone} alt="phone" style={{ width: "100%" }} />
//               </div>

//               <p
//                 className="mb-0 ml-2"
//                 style={{ fontSize: "14px", fontWeight: "400" }}
//               >
//                 {initiateDetails?.owner?.phone}
//               </p>
//             </div>
//             <div className="ml-2 mt-1">
//               <p
//                 className="mb-0 ml-2"
//                 style={{
//                   fontSize: "14px",
//                   fontWeight: "400",
//                   color: "#898989",
//                 }}
//               >
//                 Pick Up Code
//               </p>
//               <p
//                 className="mb-0 ml-2"
//                 style={{ fontSize: "14px", fontWeight: "600" }}
//               >
//                 {initiateDetails?.code}
//               </p>
//             </div>
//           </div>
//         </div>
//         <div className="">
//           {payment?.owner?.roles[0] === "corporate" ? (
//             <div className="form-group">
//               <label for="exampleFormControlSelect1">
//                 Select Payment Method
//               </label>
//               <select
//                 className="form-control"
//                 id="exampleFormControlSelect1"
//                 onChange={(e) => {
//                   setSelectedMethod(e.target.value);
//                   // console.log(e.target.value);

//                   localStorage.setItem("paymentMethods", e.target.value);
//                 }}
//                 value={selectedMethod}
//               >
//                 <option value="">Select</option>
//                 <option value="transfer">Transfer To Switch Wallet</option>
//                 {/* <option value="cash">Cash</option> */}
//               </select>
//             </div>
//           ) : (
//             <div className="form-group">
//               <label for="exampleFormControlSelect1">
//                 Select Payment Method
//               </label>
//               <select
//                 className="form-control"
//                 id="exampleFormControlSelect1"
//                 onChange={(e) => {
//                   setSelectedMethod(e.target.value);
//                   // console.log(e.target.value);

//                   localStorage.setItem("paymentMethods", e.target.value);
//                 }}
//                 value={selectedMethod}
//               >
//                 <option value="">Select</option>
//                 <option value="transfer">Transfer To Switch Wallet</option>
//                 <option value="cash">Cash</option>
//               </select>
//             </div>
//           )}
//         </div>

//         <div>
//           <h6 className="py-3">Used Plastic Categories</h6>

//           <div className="category-selector mb-3">
//             <input
//               type="text"
//               className="form-control form-control-lg inputStyle"
//               placeholder={placeholderText}
//               onClick={handleInputClick}
//               readOnly
//             />

//             {isDropdownOpen && (
//               <div
//                 ref={dropdownRef}
//                 className="dropdown mt-2 w-100"
//                 onClick={(event) => event.stopPropagation()}
//               >
//                 {categories.map((category, index) => (
//                   <div key={category} className="dropdown-item">
//                     <label className=" d-flex">
//                       <input
//                         type="checkbox"
//                         id={`checkbox-${index}`} // Unique ID for each checkbox
//                         checked={selectedCategories.includes(category)}
//                         onChange={() => {
//                           handleCheckboxChange(category);
//                           // Clear values when category is deselected
//                           if (selectedCategories.includes(category)) {
//                             switch (category) {
//                               case "Clean Sorted":
//                                 setCleanSortedKg("");
//                                 setCleanSortedAmount(null);
//                                 setCleanSortedDeduction("");
//                                 break;
//                               case "Clean Unsorted":
//                                 setCleanUnsortedKg("");
//                                 setCleanUnsortedAmount(null);
//                                 setCleanUnsortedDeduction("");
//                                 break;
//                               case "Mixed Plastics":
//                                 setMixedPlasticsKg("");
//                                 setMixedPlasticsAmount(null);
//                                 setMixedPlasticsDeduction("");
//                                 break;
//                               case "Pure Water Nylon":
//                                 setPureWaterKg("");
//                                 setPureWaterAmount(null);
//                                 setPureWaterDeduction("");
//                                 break;
//                               case "Single color caps":
//                                 setSingleColorKg("");
//                                 setSingleColorAmount(null);
//                                 setSingleColorDeduction("");
//                                 break;
//                               case "Hard packing bags (dry)":
//                                 setHardPackagingKg("");
//                                 setHardPackagingAmount(null);
//                                 setHardPackagingDeduction("");
//                                 break;
//                               case "HDPE plastics below 5 Litres":
//                                 setHdpeKg("");
//                                 setHdpeAmount(null);
//                                 setHdpeDeduction("");
//                                 break;
//                               case "PP Plastics":
//                                 setPpKg("");
//                                 setPpAmount(null);
//                                 setPpDeduction("");
//                                 break;
//                               case "Pure Water Packaging Bags":
//                                 setPackagingBagKg("");
//                                 setPackagingBagAmount(null);
//                                 setPackagingBagDeduction("");
//                                 break;
//                               case "Aluminum Cans":
//                                 setCansKg("");
//                                 setCansAmount(null);
//                                 setCansDeduction("");
//                                 break;
//                               case "Bottle Preform":
//                                 setBottlePreformKg("");
//                                 setBottlePreformAmount(null);
//                                 setBottlePreformDeduction("");
//                                 break;
//                               case "Tin Cans":
//                                 setTinCansKg("");
//                                 setTinCansAmount(null);
//                                 setTinCansDeduction("");
//                                 break;
//                             }
//                           }
//                         }}
//                       />
//                       <p className="mb-0 pl-2">{category}</p>
//                     </label>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>

//           {selectedCategories.includes("Clean Sorted") && (
//             <div className="cardss">
//               <div className="d-flex justify-content-between align-items-center">
//                 <p
//                   className="mb-0"
//                   style={{ fontWeight: "500", fontSize: "16px" }}
//                 >
//                   Clean Sorted
//                 </p>
//                 <div>
//                   <div className="">
//                     <a href="#" style={{ color: "#231F20", fontSize: "14px" }}>
//                       View Category Info
//                       <span
//                         style={{ color: "#c4da00", fontSize: "12px" }}
//                         className="ml-1"
//                       >
//                         &#62;
//                       </span>
//                     </a>
//                   </div>
//                 </div>
//               </div>
//               <div>
//                 <div className="mb-3 mt-2">
//                   <label className="mb-1 form-label">Clean Sorted</label>
//                   <input
//                     type="text"
//                     className="form-control form-control-lg inputStyle"
//                     placeholder="Enter weight in KG"
//                     value={cleanSortedKg}
//                     onChange={(e) => setCleanSortedKg(e.target.value)}
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label className="mb-1 form-label">Amount in Naira</label>
//                   <div
//                     style={{ backgroundColor: "#F8FFF8", border: "none" }}
//                     className="d-flex justify-content-between align-items-center"
//                   >
//                     <input
//                       type="text"
//                       className="form-control form-control-lg inputStyle"
//                       placeholder="N0.00"
//                       style={{ backgroundColor: "#F8FFF8", border: "none" }}
//                       value={`₦${
//                         cleanSortedAmount === null ? 0 : cleanSortedAmount
//                       }`}
//                       disabled
//                     />
//                     {form.deductSorted ? (
//                       <p className="mb-0 pr-3">{`-${form.deductSorted}%`}</p>
//                     ) : (
//                       <p className="mb-0 pr-3">{form.deductSorted}</p>
//                     )}
//                   </div>
//                 </div>
//                 <div className="text-center">
//                   <div className="" onClick={handleShowSorted}>
//                     <p style={{ color: "#231F20", fontSize: "14px" }}>
//                       Noticed Impurities? Reduce price
//                       <span
//                         style={{ color: "#c4da00", fontSize: "12px" }}
//                         className="ml-1"
//                       >
//                         &#62;
//                       </span>
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//           {selectedCategories.includes("Clean Unsorted") && (
//             <div className="cardss mt-4">
//               <div className="d-flex justify-content-between align-items-center">
//                 <p
//                   className="mb-0"
//                   style={{ fontWeight: "500", fontSize: "16px" }}
//                 >
//                   Clean Unsorted
//                 </p>
//                 <div>
//                   <div className="">
//                     <a href="#" style={{ color: "#231F20", fontSize: "14px" }}>
//                       View Category Info
//                       <span
//                         style={{ color: "#c4da00", fontSize: "12px" }}
//                         className="ml-1"
//                       >
//                         &#62;
//                       </span>
//                     </a>
//                   </div>
//                 </div>
//               </div>
//               <div>
//                 <div className="mb-3 mt-2">
//                   <label className="mb-1 form-label">Clean Unsorted</label>
//                   <input
//                     type="text"
//                     className="form-control form-control-lg inputStyle"
//                     placeholder="Enter weight in KG"
//                     value={cleanUnsortedKg}
//                     onChange={(e) => setCleanUnsortedKg(e.target.value)}
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label className="mb-1 form-label">Amount in Naira</label>
//                   <div
//                     style={{ backgroundColor: "#F8FFF8", border: "none" }}
//                     className="d-flex justify-content-between align-items-center"
//                   >
//                     <input
//                       type="text"
//                       className="form-control form-control-lg inputStyle"
//                       placeholder="N0.00"
//                       style={{ backgroundColor: "#F8FFF8", border: "none" }}
//                       value={`₦${
//                         cleanUnsortedAmount === null ? 0 : cleanUnsortedAmount
//                       }`}
//                       disabled
//                     />
//                     {form.deductUnsorted ? (
//                       <p className="mb-0 pr-3">{`-${form.deductUnsorted}%`}</p>
//                     ) : (
//                       <p className="mb-0 pr-3">{form.deductUnsorted}</p>
//                     )}
//                   </div>
//                 </div>
//                 <div className="text-center" onClick={handleShowUnsorted}>
//                   <div className="">
//                     <p style={{ color: "#231F20", fontSize: "14px" }}>
//                       Noticed Impurities? Reduce price
//                       <span
//                         style={{ color: "#c4da00", fontSize: "12px" }}
//                         className="ml-1"
//                       >
//                         &#62;
//                       </span>
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {selectedCategories.includes("Mixed Plastics") && (
//             <div className="cardss mt-4 mb-4">
//               <div className="d-flex justify-content-between align-items-center">
//                 <p
//                   className="mb-0"
//                   style={{ fontWeight: "500", fontSize: "16px" }}
//                 >
//                   Mixed Plastics
//                 </p>
//                 <div>
//                   <div className="">
//                     <a href="#" style={{ color: "#231F20", fontSize: "14px" }}>
//                       View Category Info
//                       <span
//                         style={{ color: "#c4da00", fontSize: "12px" }}
//                         className="ml-1"
//                       >
//                         &#62;
//                       </span>
//                     </a>
//                   </div>
//                 </div>
//               </div>
//               <div>
//                 <div className="mb-3 mt-2">
//                   <label className="mb-1 form-label">Mixed Plastics</label>
//                   <input
//                     type="text"
//                     className="form-control form-control-lg inputStyle"
//                     placeholder="Enter weight in KG"
//                     value={mixedPlasticsKg}
//                     onChange={(e) => setMixedPlasticsKg(e.target.value)}
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label className="mb-1 form-label">Amount in Naira</label>
//                   <div
//                     style={{ backgroundColor: "#F8FFF8", border: "none" }}
//                     className="d-flex justify-content-between align-items-center"
//                   >
//                     <input
//                       type="text"
//                       className="form-control form-control-lg inputStyle"
//                       placeholder="N0.00"
//                       style={{ backgroundColor: "#F8FFF8", border: "none" }}
//                       value={`₦${
//                         mixedPlasticsAmount === null ? 0 : mixedPlasticsAmount
//                       }`}
//                       disabled
//                     />
//                     {form.deductMixed ? (
//                       <p className="mb-0 pr-3">{`-${form.deductMixed}%`}</p>
//                     ) : (
//                       <p className="mb-0 pr-3">{form.deductMixed}</p>
//                     )}
//                   </div>
//                 </div>
//                 <div className="text-center" onClick={handleShowMixed}>
//                   <div className="">
//                     <p style={{ color: "#231F20", fontSize: "14px" }}>
//                       Noticed Impurities? Reduce price
//                       <span
//                         style={{ color: "#c4da00", fontSize: "12px" }}
//                         className="ml-1"
//                       >
//                         &#62;
//                       </span>
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {selectedCategories.includes("Pure Water Nylon") && (
//             <div className="cardss mt-4 mb-4">
//               <div className="d-flex justify-content-between align-items-center">
//                 <p
//                   className="mb-0"
//                   style={{ fontWeight: "500", fontSize: "16px" }}
//                 >
//                   Pure Water Nylon
//                 </p>
//                 <div>
//                   <div className="">
//                     <a href="#" style={{ color: "#231F20", fontSize: "14px" }}>
//                       View Category Info
//                       <span
//                         style={{ color: "#c4da00", fontSize: "12px" }}
//                         className="ml-1"
//                       >
//                         &#62;
//                       </span>
//                     </a>
//                   </div>
//                 </div>
//               </div>
//               <div>
//                 <div className="mb-3 mt-2">
//                   <label className="mb-1 form-label">Pure Water Nylon</label>
//                   <input
//                     type="text"
//                     className="form-control form-control-lg inputStyle"
//                     placeholder="Enter weight in KG"
//                     value={pureWaterKg}
//                     onChange={(e) => setPureWaterKg(e.target.value)}
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label className="mb-1 form-label">Amount in Naira</label>
//                   <div
//                     style={{ backgroundColor: "#F8FFF8", border: "none" }}
//                     className="d-flex justify-content-between align-items-center"
//                   >
//                     <input
//                       type="text"
//                       className="form-control form-control-lg inputStyle"
//                       placeholder="N0.00"
//                       style={{ backgroundColor: "#F8FFF8", border: "none" }}
//                       value={`₦${
//                         pureWaterAmount === null ? 0 : pureWaterAmount
//                       }`}
//                       disabled
//                     />
//                     {form.deductSinglePureWater ? (
//                       <p className="mb-0 pr-3">{`-${form.deductSinglePureWater}%`}</p>
//                     ) : (
//                       <p className="mb-0 pr-3">{form.deductSinglePureWater}</p>
//                     )}
//                   </div>
//                 </div>
//                 <div className="text-center" onClick={handleShowPureWater}>
//                   <div className="">
//                     <p style={{ color: "#231F20", fontSize: "14px" }}>
//                       Noticed Impurities? Reduce price
//                       <span
//                         style={{ color: "#c4da00", fontSize: "12px" }}
//                         className="ml-1"
//                       >
//                         &#62;
//                       </span>
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {selectedCategories.includes("Single color caps") && (
//             <div className="cardss mt-4">
//               <div className="d-flex justify-content-between align-items-center">
//                 <p
//                   className="mb-0"
//                   style={{ fontWeight: "500", fontSize: "16px" }}
//                 >
//                   Single color caps
//                 </p>
//                 <div>
//                   <div className="">
//                     <a href="#" style={{ color: "#231F20", fontSize: "14px" }}>
//                       View Category Info
//                       <span
//                         style={{ color: "#c4da00", fontSize: "12px" }}
//                         className="ml-1"
//                       >
//                         &#62;
//                       </span>
//                     </a>
//                   </div>
//                 </div>
//               </div>
//               <div>
//                 <div className="mb-3 mt-2">
//                   <label className="mb-1 form-label"> Single color caps</label>
//                   <input
//                     type="text"
//                     className="form-control form-control-lg inputStyle"
//                     placeholder="Enter weight in KG"
//                     value={singleColorKg}
//                     onChange={(e) => setSingleColorKg(e.target.value)}
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label className="mb-1 form-label">Amount in Naira</label>
//                   <div
//                     style={{ backgroundColor: "#F8FFF8", border: "none" }}
//                     className="d-flex justify-content-between align-items-center"
//                   >
//                     <input
//                       type="text"
//                       className="form-control form-control-lg inputStyle"
//                       placeholder="N0.00"
//                       style={{ backgroundColor: "#F8FFF8", border: "none" }}
//                       value={`₦${
//                         singleColorAmount === null ? 0 : singleColorAmount
//                       }`}
//                       disabled
//                     />
//                     {form.deductSingleColor ? (
//                       <p className="mb-0 pr-3">{`-${form.deductSingleColor}%`}</p>
//                     ) : (
//                       <p className="mb-0 pr-3">{form.deductSingleColor}</p>
//                     )}
//                   </div>
//                 </div>
//                 <div className="text-center" onClick={handleShowSingleColor}>
//                   <div className="">
//                     <p style={{ color: "#231F20", fontSize: "14px" }}>
//                       Noticed Impurities? Reduce price
//                       <span
//                         style={{ color: "#c4da00", fontSize: "12px" }}
//                         className="ml-1"
//                       >
//                         &#62;
//                       </span>
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {selectedCategories.includes("Hard packing bags (dry)") && (
//             <div className="cardss mt-4 mb-4">
//               <div className="d-flex justify-content-between align-items-center">
//                 <p
//                   className="mb-0"
//                   style={{ fontWeight: "500", fontSize: "16px" }}
//                 >
//                   Hard packing bags (dry)
//                 </p>
//                 <div>
//                   <div className="">
//                     <a href="#" style={{ color: "#231F20", fontSize: "14px" }}>
//                       View Category Info
//                       <span
//                         style={{ color: "#c4da00", fontSize: "12px" }}
//                         className="ml-1"
//                       >
//                         &#62;
//                       </span>
//                     </a>
//                   </div>
//                 </div>
//               </div>
//               <div>
//                 <div className="mb-3 mt-2">
//                   <label className="mb-1 form-label">
//                     Hard packing bags (dry)
//                   </label>
//                   <input
//                     type="text"
//                     className="form-control form-control-lg inputStyle"
//                     placeholder="Enter weight in KG"
//                     value={hardPackagingKg}
//                     onChange={(e) => setHardPackagingKg(e.target.value)}
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label className="mb-1 form-label">Amount in Naira</label>
//                   <div
//                     style={{ backgroundColor: "#F8FFF8", border: "none" }}
//                     className="d-flex justify-content-between align-items-center"
//                   >
//                     <input
//                       type="text"
//                       className="form-control form-control-lg inputStyle"
//                       placeholder="N0.00"
//                       style={{ backgroundColor: "#F8FFF8", border: "none" }}
//                       value={`₦${
//                         hardPackagingAmount === null ? 0 : hardPackagingAmount
//                       }`}
//                       disabled
//                     />
//                     {form.deductHardPackaging ? (
//                       <p className="mb-0 pr-3">{`-${form.deductHardPackaging}%`}</p>
//                     ) : (
//                       <p className="mb-0 pr-3">{form.deductHardPackaging}</p>
//                     )}
//                   </div>
//                 </div>
//                 <div className="text-center" onClick={handleShowHardPackaging}>
//                   <div className="">
//                     <p style={{ color: "#231F20", fontSize: "14px" }}>
//                       Noticed Impurities? Reduce price
//                       <span
//                         style={{ color: "#c4da00", fontSize: "12px" }}
//                         className="ml-1"
//                       >
//                         &#62;
//                       </span>
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {selectedCategories.includes("HDPE plastics below 5 Litres") && (
//             <div className="cardss mt-4 mb-4">
//               <div className="d-flex justify-content-between align-items-center">
//                 <p
//                   className="mb-0"
//                   style={{ fontWeight: "500", fontSize: "16px" }}
//                 >
//                   HDPE plastics below 5 Litres
//                 </p>
//                 <div>
//                   {/* <div className="">
//                   <a href="#" style={{ color: "#231F20", fontSize: "14px" }}>
//                     View Category Info
//                     <span
//                       style={{ color: "#c4da00", fontSize: "12px" }}
//                       className="ml-1"
//                     >
//                       &#62;
//                     </span>
//                   </a>
//                 </div> */}
//                 </div>
//               </div>
//               <div>
//                 <div className="mb-3 mt-2">
//                   <label className="mb-1 form-label">
//                     HDPE plastics below 5 metres
//                   </label>
//                   <input
//                     type="text"
//                     className="form-control form-control-lg inputStyle"
//                     placeholder="Enter weight in KG"
//                     value={hdpeKg}
//                     onChange={(e) => setHdpeKg(e.target.value)}
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label className="mb-1 form-label">Amount in Naira</label>
//                   <div
//                     style={{ backgroundColor: "#F8FFF8", border: "none" }}
//                     className="d-flex justify-content-between align-items-center"
//                   >
//                     <input
//                       type="text"
//                       className="form-control form-control-lg inputStyle"
//                       placeholder="N0.00"
//                       style={{ backgroundColor: "#F8FFF8", border: "none" }}
//                       value={`₦${hdpeAmount === null ? 0 : hdpeAmount}`}
//                       disabled
//                     />
//                     {form.deductHdpe ? (
//                       <p className="mb-0 pr-3">{`-${form.deductHdpe}%`}</p>
//                     ) : (
//                       <p className="mb-0 pr-3">{form.deductHdpe}</p>
//                     )}
//                   </div>
//                 </div>
//                 <div className="text-center" onClick={handleShowhdpe}>
//                   <div className="">
//                     <p style={{ color: "#231F20", fontSize: "14px" }}>
//                       Noticed Impurities? Reduce price
//                       <span
//                         style={{ color: "#c4da00", fontSize: "12px" }}
//                         className="ml-1"
//                       >
//                         &#62;
//                       </span>
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {selectedCategories.includes("PP Plastics") && (
//             <div className="cardss mt-4 mb-4">
//               <div className="d-flex justify-content-between align-items-center">
//                 <p
//                   className="mb-0"
//                   style={{ fontWeight: "500", fontSize: "16px" }}
//                 >
//                   PP Plastics
//                 </p>
//                 <div>
//                   <div className="">
//                     <a href="#" style={{ color: "#231F20", fontSize: "14px" }}>
//                       View Category Info
//                       <span
//                         style={{ color: "#c4da00", fontSize: "12px" }}
//                         className="ml-1"
//                       >
//                         &#62;
//                       </span>
//                     </a>
//                   </div>
//                 </div>
//               </div>
//               <div>
//                 <div className="mb-3 mt-2">
//                   <label className="mb-1 form-label">PP Plastics</label>
//                   <input
//                     type="text"
//                     className="form-control form-control-lg inputStyle"
//                     placeholder="Enter weight in KG"
//                     value={ppKg}
//                     onChange={(e) => setPpKg(e.target.value)}
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label className="mb-1 form-label">Amount in Naira</label>
//                   <div
//                     style={{ backgroundColor: "#F8FFF8", border: "none" }}
//                     className="d-flex justify-content-between align-items-center"
//                   >
//                     <input
//                       type="text"
//                       className="form-control form-control-lg inputStyle"
//                       placeholder="N0.00"
//                       style={{ backgroundColor: "#F8FFF8", border: "none" }}
//                       value={`₦${ppAmount === null ? 0 : ppAmount}`}
//                       disabled
//                     />
//                     {form.deductPp ? (
//                       <p className="mb-0 pr-3">{`-${form.deductPp}%`}</p>
//                     ) : (
//                       <p className="mb-0 pr-3">{form.deductPp}</p>
//                     )}
//                   </div>
//                 </div>
//                 <div className="text-center" onClick={handleShowPp}>
//                   <div className="">
//                     <p style={{ color: "#231F20", fontSize: "14px" }}>
//                       Noticed Impurities? Reduce price
//                       <span
//                         style={{ color: "#c4da00", fontSize: "12px" }}
//                         className="ml-1"
//                       >
//                         &#62;
//                       </span>
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {selectedCategories.includes("Pure Water Packaging Bags") && (
//             <div className="cardss mt-4 mb-4">
//               <div className="d-flex justify-content-between align-items-center">
//                 <p
//                   className="mb-0"
//                   style={{ fontWeight: "500", fontSize: "16px" }}
//                 >
//                   Pure Water Packaging Bags
//                 </p>
//                 <div>
//                   <div className="">
//                     <a href="#" style={{ color: "#231F20", fontSize: "14px" }}>
//                       View Category Info
//                       <span
//                         style={{ color: "#c4da00", fontSize: "12px" }}
//                         className="ml-1"
//                       >
//                         &#62;
//                       </span>
//                     </a>
//                   </div>
//                 </div>
//               </div>
//               <div>
//                 <div className="mb-3 mt-2">
//                   <label className="mb-1 form-label">Packaging Bags</label>
//                   <input
//                     type="text"
//                     className="form-control form-control-lg inputStyle"
//                     placeholder="Enter weight in KG"
//                     value={packagingBagKg}
//                     onChange={(e) => setPackagingBagKg(e.target.value)}
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label className="mb-1 form-label">Amount in Naira</label>
//                   <div
//                     style={{ backgroundColor: "#F8FFF8", border: "none" }}
//                     className="d-flex justify-content-between align-items-center"
//                   >
//                     <input
//                       type="text"
//                       className="form-control form-control-lg inputStyle"
//                       placeholder="N0.00"
//                       style={{ backgroundColor: "#F8FFF8", border: "none" }}
//                       value={`₦${
//                         packagingBagAmount === null ? 0 : packagingBagAmount
//                       }`}
//                       disabled
//                     />
//                     {form.deductPackagingBag ? (
//                       <p className="mb-0 pr-3">{`-${form.deductPackagingBag}%`}</p>
//                     ) : (
//                       <p className="mb-0 pr-3">{form.deductPackagingBag}</p>
//                     )}
//                   </div>
//                 </div>
//                 <div className="text-center" onClick={handleShowPackagingBag}>
//                   <div className="">
//                     <p style={{ color: "#231F20", fontSize: "14px" }}>
//                       Noticed Impurities? Reduce price
//                       <span
//                         style={{ color: "#c4da00", fontSize: "12px" }}
//                         className="ml-1"
//                       >
//                         &#62;
//                       </span>
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {selectedCategories.includes("Aluminum Cans") && (
//             <div className="cardss mt-4 mb-4">
//               <div className="d-flex justify-content-between align-items-center">
//                 <p
//                   className="mb-0"
//                   style={{ fontWeight: "500", fontSize: "16px" }}
//                 >
//                   Aluminum Cans
//                 </p>
//                 <div>
//                   <div className="">
//                     <a href="#" style={{ color: "#231F20", fontSize: "14px" }}>
//                       View Category Info
//                       <span
//                         style={{ color: "#c4da00", fontSize: "12px" }}
//                         className="ml-1"
//                       >
//                         &#62;
//                       </span>
//                     </a>
//                   </div>
//                 </div>
//               </div>
//               <div>
//                 <div className="mb-3 mt-2">
//                   <label className="mb-1 form-label">Aluminum Cans</label>
//                   <input
//                     type="text"
//                     className="form-control form-control-lg inputStyle"
//                     placeholder="Enter weight in KG"
//                     value={cansKg}
//                     onChange={(e) => setCansKg(e.target.value)}
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label className="mb-1 form-label">Amount in Naira</label>
//                   <div
//                     style={{ backgroundColor: "#F8FFF8", border: "none" }}
//                     className="d-flex justify-content-between align-items-center"
//                   >
//                     <input
//                       type="text"
//                       className="form-control form-control-lg inputStyle"
//                       placeholder="N0.00"
//                       style={{ backgroundColor: "#F8FFF8", border: "none" }}
//                       value={`₦${cansAmount === null ? 0 : cansAmount}`}
//                       disabled
//                     />
//                     {form.deductCans ? (
//                       <p className="mb-0 pr-3">{`-${form.deductCans}%`}</p>
//                     ) : (
//                       <p className="mb-0 pr-3">{form.deductCans}</p>
//                     )}
//                   </div>
//                 </div>
//                 <div className="text-center" onClick={handleShowCans}>
//                   <div className="">
//                     <p style={{ color: "#231F20", fontSize: "14px" }}>
//                       Noticed Impurities? Reduce price
//                       <span
//                         style={{ color: "#c4da00", fontSize: "12px" }}
//                         className="ml-1"
//                       >
//                         &#62;
//                       </span>
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {selectedCategories.includes("Bottle Preform") && (
//             <div className="cardss mt-4 mb-4">
//               <div className="d-flex justify-content-between align-items-center">
//                 <p
//                   className="mb-0"
//                   style={{ fontWeight: "500", fontSize: "16px" }}
//                 >
//                   Bottle Preform
//                 </p>
//                 <div>
//                   <div className="">
//                     <a href="#" style={{ color: "#231F20", fontSize: "14px" }}>
//                       View Category Info
//                       <span
//                         style={{ color: "#c4da00", fontSize: "12px" }}
//                         className="ml-1"
//                       >
//                         &#62;
//                       </span>
//                     </a>
//                   </div>
//                 </div>
//               </div>
//               <div>
//                 <div className="mb-3 mt-2">
//                   <label className="mb-1 form-label">Bottle Preform</label>
//                   <input
//                     type="text"
//                     className="form-control form-control-lg inputStyle"
//                     placeholder="Enter weight in KG"
//                     value={bottlePreformKg}
//                     onChange={(e) => setBottlePreformKg(e.target.value)}
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label className="mb-1 form-label">Amount in Naira</label>
//                   <div
//                     style={{ backgroundColor: "#F8FFF8", border: "none" }}
//                     className="d-flex justify-content-between align-items-center"
//                   >
//                     <input
//                       type="text"
//                       className="form-control form-control-lg inputStyle"
//                       placeholder="N0.00"
//                       style={{ backgroundColor: "#F8FFF8", border: "none" }}
//                       value={`₦${
//                         bottlePreformAmount === null ? 0 : bottlePreformAmount
//                       }`}
//                       disabled
//                     />
//                     {form.deductBottlePreform ? (
//                       <p className="mb-0 pr-3">{`-${form.deductBottlePreform}%`}</p>
//                     ) : (
//                       <p className="mb-0 pr-3">{form.deductBottlePreform}</p>
//                     )}
//                   </div>
//                 </div>
//                 <div className="text-center" onClick={handleShowBottlePreform}>
//                   <div className="">
//                     <p style={{ color: "#231F20", fontSize: "14px" }}>
//                       Noticed Impurities? Reduce price
//                       <span
//                         style={{ color: "#c4da00", fontSize: "12px" }}
//                         className="ml-1"
//                       >
//                         &#62;
//                       </span>
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {selectedCategories.includes("Tin Cans") && (
//             <div className="cardss mt-4 mb-4">
//               <div className="d-flex justify-content-between align-items-center">
//                 <p
//                   className="mb-0"
//                   style={{ fontWeight: "500", fontSize: "16px" }}
//                 >
//                   Tin Cans
//                 </p>
//                 <div>
//                   <div className="">
//                     <a href="#" style={{ color: "#231F20", fontSize: "14px" }}>
//                       View Category Info
//                       <span
//                         style={{ color: "#c4da00", fontSize: "12px" }}
//                         className="ml-1"
//                       >
//                         &#62;
//                       </span>
//                     </a>
//                   </div>
//                 </div>
//               </div>
//               <div>
//                 <div className="mb-3 mt-2">
//                   <label className="mb-1 form-label">Tin Cans</label>
//                   <input
//                     type="text"
//                     className="form-control form-control-lg inputStyle"
//                     placeholder="Enter weight in KG"
//                     value={tinCansKg}
//                     onChange={(e) => setTinCansKg(e.target.value)}
//                   />
//                 </div>
//                 <div className="mb-3">
//                   <label className="mb-1 form-label">Amount in Naira</label>
//                   <div
//                     style={{ backgroundColor: "#F8FFF8", border: "none" }}
//                     className="d-flex justify-content-between align-items-center"
//                   >
//                     <input
//                       type="text"
//                       className="form-control form-control-lg inputStyle"
//                       placeholder="N0.00"
//                       style={{ backgroundColor: "#F8FFF8", border: "none" }}
//                       value={`₦${tinCansAmount === null ? 0 : tinCansAmount}`}
//                       disabled
//                     />
//                     {form.deductTinCans ? (
//                       <p className="mb-0 pr-3">{`-${form.deductTinCans}%`}</p>
//                     ) : (
//                       <p className="mb-0 pr-3">{form.deductTinCans}</p>
//                     )}
//                   </div>
//                 </div>
//                 <div className="text-center" onClick={handleShowTinCans}>
//                   <div className="">
//                     <p style={{ color: "#231F20", fontSize: "14px" }}>
//                       Noticed Impurities? Reduce price
//                       <span
//                         style={{ color: "#c4da00", fontSize: "12px" }}
//                         className="ml-1"
//                       >
//                         &#62;
//                       </span>
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           <div className="pb-2">
//             <div className="mb-3">
//               <label className="mb-1 form-label">Deductions</label>
//               <input
//                 type="text"
//                 className="form-control form-control-lg inputStyle bg-dark text-white"
//                 placeholder="N0.00"
//                 value={`₦${
//                   Math.round((totalDeduction + Number.EPSILON) * 100) / 100
//                 }`}
//                 disabled
//               />
//             </div>
//           </div>

//           <div className="pb-2">
//             <div className="mb-3">
//               <label className="mb-1 form-label">Sum Total</label>
//               <input
//                 type="text"
//                 className="form-control form-control-lg inputStyle bg-dark text-white"
//                 placeholder="N0.00"
//                 value={`₦${
//                   Math.round((finalValue + Number.EPSILON) * 100) / 100
//                 }`}
//                 disabled
//               />
//             </div>
//           </div>
//           <div className="pb-5">
//             <button
//               type="button"
//               className="btn loginBtn btn-sm btn-block"
//               onClick={initiatePickUp}
//               disabled={loading || selectedCategories.length <= 0}
//             >
//               {loading ? (
//                 <span
//                   style={{
//                     color: "white",
//                     marginLeft: "2px",
//                     marginTop: "1px",
//                   }}
//                   className="text-center"
//                 >
//                   <Spinner
//                     as="span"
//                     animation="border"
//                     size="sm"
//                     role="status"
//                     aria-hidden="true"
//                   />
//                 </span>
//               ) : (
//                 "Initiate Payment"
//               )}
//             </button>
//           </div>
//         </div>
//       </div>

//       <SortedeModal
//         showSorted={showSorted}
//         handleCloseSorted={handleCloseSorted}
//         form={form}
//         handleFormChange={handleFormChange}
//         cleanSortedDeduction={cleanSortedDeduction}
//         cleanSortedKg={cleanSortedKg}
//         handleInputChangeCS={handleInputChangeCS}
//       />

//       <UnsortedeModal
//         showUnsorted={showUnsorted}
//         handleCloseUnsorted={handleCloseUnsorted}
//         form={form}
//         handleFormChange={handleFormChange}
//         unsortedValue={unsortedValue}
//         cleanUnsortedDeduction={cleanUnsortedDeduction}
//         cleanUnsortedKg={cleanUnsortedKg}
//         handleInputChangeCU={handleInputChangeCU}
//       />

//       <MixedModal
//         showMixed={showMixed}
//         handleCloseMixed={handleCloseMixed}
//         form={form}
//         handleFormChange={handleFormChange}
//         mixedValue={mixedValue}
//         mixedPlasticsDeduction={mixedPlasticsDeduction}
//         mixedPlasticsKg={mixedPlasticsKg}
//         handleInputChangeMx={handleInputChangeMx}
//       />

//       <SingleColorModal
//         showSingleColor={showSingleColor}
//         handleCloseSingleColor={handleCloseSingleColor}
//         form={form}
//         handleFormChange={handleFormChange}
//         singleColorValue={singleColorValue}
//         singleColorDeduction={singleColorDeduction}
//         singleColorKg={singleColorKg}
//         handleInputChangeSC={handleInputChangeSC}
//       />

//       <PureWaterModal
//         showPureWater={showPureWater}
//         handleClosePureWater={handleClosePureWater}
//         pureWaterValue={pureWaterValue}
//         form={form}
//         handleFormChange={handleFormChange}
//         pureWaterDeduction={pureWaterDeduction}
//         pureWaterKg={pureWaterKg}
//         handleInputChangePw={handleInputChangePw}
//       />

//       <HardPackagingModal
//         form={form}
//         handleFormChange={handleFormChange}
//         hardPackagingValue={hardPackagingValue}
//         showHardPackaging={showHardPackaging}
//         handleCloseHardPackaging={handleCloseHardPackaging}
//         hardPackagingDeduction={hardPackagingDeduction}
//         hardPackagingKg={hardPackagingKg}
//         handleInputChangeHP={handleInputChangeHP}
//       />

//       <HdpeModal
//         showhdpe={showhdpe}
//         handleClosehdpe={handleClosehdpe}
//         form={form}
//         handleFormChange={handleFormChange}
//         hdpeValue={hdpeValue}
//         hdpeDeduction={hdpeDeduction}
//         hdpeKg={hdpeKg}
//         handleInputChangeHD={handleInputChangeHD}
//       />

//       <PPModal
//         form={form}
//         handleFormChange={handleFormChange}
//         ppValue={ppValue}
//         showPp={showPp}
//         handleClosePp={handleClosePp}
//         ppDeduction={ppDeduction}
//         ppKg={ppKg}
//         handleInputChangePP={handleInputChangePP}
//       />

//       <PackagingBagModal
//         form={form}
//         handleFormChange={handleFormChange}
//         packagingBagValue={packagingBagValue}
//         showPackagingBag={showPackagingBag}
//         handleClosePackagingBag={handleClosePackagingBag}
//         packagingBagDeduction={packagingBagDeduction}
//         packagingBagKg={packagingBagKg}
//         handleInputChangePB={handleInputChangePB}
//       />

//       <CansModal
//         form={form}
//         handleFormChange={handleFormChange}
//         cansValue={cansValue}
//         showCans={showCans}
//         handleCloseCans={handleCloseCans}
//         cansDeduction={cansDeduction}
//         cansKg={cansKg}
//         handleInputChangeCans={handleInputChangeCans}
//       />

//       <BottlePreformModal
//         form={form}
//         handleFormChange={handleFormChange}
//         bottlePreformValue={bottlePreformValue}
//         showBottlePreform={showBottlePreform}
//         handleCloseBottlePreform={handleCloseBottlePreform}
//         bottlePreformDeduction={bottlePreformDeduction}
//         bottlePreformKg={bottlePreformKg}
//         handleInputChangeBottlePreform={handleInputChangeBottlePreform}
//       />

//       <TinCanmModal
//         form={form}
//         handleFormChange={handleFormChange}
//         tinCansValue={tinCansValue}
//         showTinCans={showTinCans}
//         handleCloseTinCans={handleCloseTinCans}
//         tinCansDeduction={tinCansDeduction}
//         tinCansKg={tinCansKg}
//         handleInputChangeTinCan={handleInputChangeTinCan}
//       />
//     </div>
//   );
// };

// export default CalculateTransaction;

// import React, { useState, useCallback } from "react";
// import { useLocation } from "react-router-dom";
// import { Spinner } from "react-bootstrap";
// import avatar from "../../../../../assets/images/avatarr.png";
// import phone from "../../../../../assets/images/phone.png";
// import DriversNavigation from "../../components/Navbar/navbar";

// // Hooks
// import useFetchCategories from "./comps/useFetchCategories";
// import useCategoryForm from "./comps/useCategoryForm";
// import usePickUpTransaction from "./comps/usePickUpTransaction";

// // Components
// import CategoryDropdown from "./comps/CategoryDropdown";
// import CategoryCard from "./comps/CategoryCard";
// import ImpurityModal from "./comps/ImpurityModal";

// const CalculateTransaction = (props) => {
//   const initiateDetails = JSON.parse(localStorage.getItem("initiate"));
//   const payment = JSON.parse(localStorage.getItem("pay"));
//   const isCorporate = payment?.owner?.roles?.[0] === "corporate";

//   // ─── Categories from API ──────────────────────────────────────────────────
//   const { categories, loading: categoriesLoading, error: categoriesError } =
//     useFetchCategories();

//   // ─── Form state ───────────────────────────────────────────────────────────
//   const {
//     categoryData,
//     updateCategory,
//     computedAmounts,
//     totals,
//     buildWastePayload,
//     resetForm,
//   } = useCategoryForm(categories);

//   // ─── UI state ─────────────────────────────────────────────────────────────
//   const [selectedCategories, setSelectedCategories] = useState([]);
//   const [selectedMethod, setSelectedMethod] = useState("");

//   // Single impurity modal state — replaces 12 individual show/hide states
//   const [impurityModal, setImpurityModal] = useState({
//     open: false,
//     categoryId: null,
//   });

//   const activeImpurityCategory = categories.find(
//     (c) => c.id === impurityModal.categoryId
//   );

//   // ─── Category selection ───────────────────────────────────────────────────
//   const handleCheckboxChange = useCallback(
//     (label) => {
//       setSelectedCategories((prev) => {
//         const isRemoving = prev.includes(label);
//         if (isRemoving) {
//           // Clear that category's data when deselected
//           const cat = categories.find((c) => c.label === label);
//           if (cat) {
//             updateCategory(cat.id, "kg", "");
//             updateCategory(cat.id, "deduction", "");
//             updateCategory(cat.id, "showDeduction", false);
//           }
//           return prev.filter((c) => c !== label);
//         }
//         return [...prev, label];
//       });
//     },
//     [categories, updateCategory]
//   );

//   // ─── Transaction success ──────────────────────────────────────────────────
//   const handleSuccess = useCallback(() => {
//     resetForm();
//     setSelectedCategories([]);
//     setSelectedMethod("");
//     props.history.push("/drivers/awaitConfirmation");
//   }, [resetForm, props.history]);

//   // ─── Transaction hook ─────────────────────────────────────────────────────
//   const { loading, initiateTransaction } = usePickUpTransaction({
//     initiateDetails,
//     onSuccess: handleSuccess,
//   });

//   // ─── Submit ───────────────────────────────────────────────────────────────
//   const handleSubmit = useCallback(() => {
//     initiateTransaction({
//       wastePayload: buildWastePayload(),
//       paymentMethod: selectedMethod,
//     });
//   }, [initiateTransaction, buildWastePayload, selectedMethod]);

//   // ─── Render ───────────────────────────────────────────────────────────────
//   return (
//     <div>
//       <DriversNavigation />

//       <div className="mx-3">
//         {/* ── User info header ── */}
//         <div
//           className="d-flex align-items-center my-3"
//           style={{ width: "300px" }}
//         >
//           <img src={avatar} alt="avatar" style={{ width: "20%" }} />
//           <div>
//             <p className="mb-1 ml-3" style={{ fontSize: "14px", fontWeight: "400" }}>
//               Household: {initiateDetails?.owner?.name}
//             </p>
//             <div className="d-flex align-items-center ml-3 mt-1">
//               <div style={{ width: "30px" }}>
//                 <img src={phone} alt="phone" style={{ width: "100%" }} />
//               </div>
//               <p className="mb-0 ml-2" style={{ fontSize: "14px", fontWeight: "400" }}>
//                 {initiateDetails?.owner?.phone}
//               </p>
//             </div>
//             <div className="ml-2 mt-1">
//               <p
//                 className="mb-0 ml-2"
//                 style={{ fontSize: "14px", fontWeight: "400", color: "#898989" }}
//               >
//                 Pick Up Code
//               </p>
//               <p className="mb-0 ml-2" style={{ fontSize: "14px", fontWeight: "600" }}>
//                 {initiateDetails?.code}
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* ── Payment method ── */}
//         <div className="form-group">
//           <label htmlFor="paymentMethodSelect">Select Payment Method</label>
//           <select
//             className="form-control"
//             id="paymentMethodSelect"
//             value={selectedMethod}
//             onChange={(e) => {
//               setSelectedMethod(e.target.value);
//               localStorage.setItem("paymentMethods", e.target.value);
//             }}
//           >
//             <option value="">Select</option>
//             <option value="transfer">Transfer To Switch Wallet</option>
//             {/* Corporate accounts only get transfer; non-corporate also get cash */}
//             {!isCorporate && <option value="cash">Cash</option>}
//           </select>
//         </div>

//         <div>
//           <h6 className="py-3">Used Plastic Categories</h6>

//           {/* ── Category loading / error ── */}
//           {categoriesLoading && (
//             <p className="text-muted" style={{ fontSize: "14px" }}>
//               Loading categories...
//             </p>
//           )}
//           {categoriesError && (
//             <p className="text-danger" style={{ fontSize: "14px" }}>
//               {categoriesError}
//             </p>
//           )}

//           {!categoriesLoading && !categoriesError && (
//             <>
//               {/* ── Category dropdown ── */}
//               <CategoryDropdown
//                 categories={categories}
//                 selected={selectedCategories}
//                 onChange={handleCheckboxChange}
//               />

//               {/* ── One card per selected category — no repetition ── */}
//               {categories
//                 .filter((cat) => selectedCategories.includes(cat.label))
//                 .map((cat) => (
//                   <CategoryCard
//                     key={cat.id}
//                     category={cat}
//                     data={categoryData[cat.id]}
//                     computed={computedAmounts[cat.id]}
//                     onChange={(field, value) =>
//                       updateCategory(cat.id, field, value)
//                     }
//                     onShowImpurity={() =>
//                       setImpurityModal({ open: true, categoryId: cat.id })
//                     }
//                   />
//                 ))}

//               {/* ── Totals ── */}
//               <div className="pb-2">
//                 <div className="mb-3">
//                   <label className="mb-1 form-label">Deductions</label>
//                   <input
//                     type="text"
//                     className="form-control form-control-lg inputStyle bg-dark text-white"
//                     placeholder="₦0.00"
//                     value={`₦${totals.totalDeduction}`}
//                     disabled
//                   />
//                 </div>
//               </div>

//               <div className="pb-2">
//                 <div className="mb-3">
//                   <label className="mb-1 form-label">Sum Total</label>
//                   <input
//                     type="text"
//                     className="form-control form-control-lg inputStyle bg-dark text-white"
//                     placeholder="₦0.00"
//                     value={`₦${totals.totalAmount}`}
//                     disabled
//                   />
//                 </div>
//               </div>

//               {/* ── Submit ── */}
//               <div className="pb-5">
//                 <button
//                   type="button"
//                   className="btn loginBtn btn-sm btn-block"
//                   onClick={handleSubmit}
//                   disabled={loading || selectedCategories.length === 0}
//                 >
//                   {loading ? (
//                     <Spinner
//                       as="span"
//                       animation="border"
//                       size="sm"
//                       role="status"
//                       aria-hidden="true"
//                     />
//                   ) : (
//                     "Initiate Payment"
//                   )}
//                 </button>
//               </div>
//             </>
//           )}
//         </div>
//       </div>

//       {/* ── Single impurity modal — replaces 12 individual modals ── */}
//       <ImpurityModal
//         show={impurityModal.open}
//         onClose={() => setImpurityModal({ open: false, categoryId: null })}
//         category={activeImpurityCategory}
//         data={activeImpurityCategory ? categoryData[activeImpurityCategory.id] : null}
//         onDeductionChange={(value) =>
//           updateCategory(impurityModal.categoryId, "deduction", value)
//         }
//       />
//     </div>
//   );
// };

// export default CalculateTransaction;


import React, { useState, useCallback } from "react";
import { Spinner } from "react-bootstrap";
import avatar from "../../../../../assets/images/avatarr.png";
import phone from "../../../../../assets/images/phone.png";
import DriversNavigation from "../../components/Navbar/navbar";

import useFetchWasteData from "./new/useFetchWaste.js";
import useCategoryForm from "./new/useCategoryForm";
import usePickUpTransaction from "./new/usePickupTransaction";
import CategoryDropdown from "./new/categoryDropdown.js";
import CategoryCard from "./new/categoryCard.js";
import ImpurityModal from "./new/impurityModal.js";
import { storage } from "../../../../../scopedStorage";

const CalculateTransaction = (props) => {
  const initiateDetails = JSON.parse(localStorage.getItem("initiate"));
  const payment = JSON.parse(localStorage.getItem("pay"));
  const isCorporate = payment?.owner?.roles?.[0] === "corporate";

  // ─── Categories + tiered pricing from single API call ────────────────────
  const { categories, pricingData, loading: categoriesLoading, error: categoriesError } =
    useFetchWasteData();

  // ─── Form state ───────────────────────────────────────────────────────────
  const {
    categoryData,
    updateCategory,
    updateKg,
    computedAmounts,
    totals,
    hasErrors,
    buildWastePayload,
    resetForm,
  } = useCategoryForm(categories, pricingData, "pickup");

  // ─── UI state ─────────────────────────────────────────────────────────────
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedMethod, setSelectedMethod] = useState("");

  const [impurityModal, setImpurityModal] = useState({
    open: false,
    categoryId: null,
  });

  const activeImpurityCategory = categories.find(
    (c) => c.id === impurityModal.categoryId
  );

  // ─── Category selection ───────────────────────────────────────────────────
  const handleCheckboxChange = useCallback(
    (label) => {
      setSelectedCategories((prev) => {
        const isRemoving = prev.includes(label);
        if (isRemoving) {
          const cat = categories.find((c) => c.label === label);
          if (cat) {
            updateCategory(cat.id, "kg", "");
            updateCategory(cat.id, "deduction", "");
            updateCategory(cat.id, "showDeduction", false);
          }
          return prev.filter((c) => c !== label);
        }
        return [...prev, label];
      });
    },
    [categories, updateCategory]
  );

  // ─── Transaction success ──────────────────────────────────────────────────
  const handleSuccess = useCallback(() => {
    resetForm();
    setSelectedCategories([]);
    setSelectedMethod("");
    props.history.push("/drivers/awaitConfirmation");
  }, [resetForm, props.history]);

  // ─── Transaction hook ─────────────────────────────────────────────────────
  const { loading, initiateTransaction } = usePickUpTransaction({
    initiateDetails,
    onSuccess: handleSuccess,
  });

  // ─── Submit ───────────────────────────────────────────────────────────────
  const handleSubmit = useCallback(() => {
    initiateTransaction({
      wastePayload: buildWastePayload(),
      paymentMethod: selectedMethod,
      hasErrors,
    });
  }, [initiateTransaction, buildWastePayload, selectedMethod, hasErrors]);

  // ─── Render ───────────────────────────────────────────────────────────────
  return (
    <div>
      <DriversNavigation />

      <div className="mx-3">
        {/* ── User info header ── */}
        <div
          className="d-flex align-items-center my-3"
          style={{ width: "300px" }}
        >
          <img src={avatar} alt="avatar" style={{ width: "20%" }} />
          <div>
            <p className="mb-1 ml-3" style={{ fontSize: "14px", fontWeight: "400" }}>
              Household: {initiateDetails?.owner?.name}
            </p>
            <div className="d-flex align-items-center ml-3 mt-1">
              <div style={{ width: "30px" }}>
                <img src={phone} alt="phone" style={{ width: "100%" }} />
              </div>
              <p className="mb-0 ml-2" style={{ fontSize: "14px", fontWeight: "400" }}>
                {initiateDetails?.owner?.phone}
              </p>
            </div>
            <div className="ml-2 mt-1">
              <p
                className="mb-0 ml-2"
                style={{ fontSize: "14px", fontWeight: "400", color: "#898989" }}
              >
                Pick Up Code
              </p>
              <p className="mb-0 ml-2" style={{ fontSize: "14px", fontWeight: "600" }}>
                {initiateDetails?.code}
              </p>
            </div>
          </div>
        </div>

        {/* ── Payment method ── */}
        <div className="form-group">
          <label htmlFor="paymentMethodSelect">Select Payment Method</label>
          <select
            className="form-control"
            id="paymentMethodSelect"
            value={selectedMethod}
            onChange={(e) => {
              setSelectedMethod(e.target.value);
              localStorage.setItem("paymentMethods", e.target.value);
            }}
          >
            <option value="">Select</option>
            <option value="transfer">Transfer To Switch Wallet</option>
            {!isCorporate && <option value="cash">Cash</option>}
          </select>
        </div>

        <div>
          <h6 className="py-3">Used Plastic Categories</h6>

          {categoriesLoading && (
            <p className="text-muted" style={{ fontSize: "14px" }}>
              Loading categories...
            </p>
          )}
          {categoriesError && (
            <p className="text-danger" style={{ fontSize: "14px" }}>
              {categoriesError}
            </p>
          )}

          {!categoriesLoading && !categoriesError && (
            <>
              <CategoryDropdown
                categories={categories}
                selected={selectedCategories}
                onChange={handleCheckboxChange}
              />

              {categories
                .filter((cat) => selectedCategories.includes(cat.label))
                .map((cat) => (
                  <CategoryCard
                    key={cat.id}
                    category={cat}
                    data={categoryData[cat.id]}
                    computed={computedAmounts[cat.id]}
                    onKgChange={(value) => updateKg(cat.id, value)}
                    onChange={(field, value) =>
                      updateCategory(cat.id, field, value)
                    }
                    onShowImpurity={() =>
                      setImpurityModal({ open: true, categoryId: cat.id })
                    }
                  />
                ))}

              {/* ── Totals ── */}
              <div className="pb-2">
                <div className="mb-3">
                  <label className="mb-1 form-label">Deductions</label>
                  <input
                    type="text"
                    className="form-control form-control-lg inputStyle bg-dark text-white"
                    placeholder="₦0.00"
                    value={`₦${totals.totalDeduction}`}
                    disabled
                  />
                </div>
              </div>

              <div className="pb-2">
                <div className="mb-3">
                  <label className="mb-1 form-label">Sum Total</label>
                  <input
                    type="text"
                    className="form-control form-control-lg inputStyle bg-dark text-white"
                    placeholder="₦0.00"
                    value={`₦${totals.totalAmount}`}
                    disabled
                  />
                </div>
              </div>

              {/* ── Submit ── */}
              <div className="pb-5">
                <button
                  type="button"
                  className="btn loginBtn btn-sm btn-block"
                  onClick={handleSubmit}
                  disabled={loading || selectedCategories.length === 0 || hasErrors}
                >
                  {loading ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    "Initiate Payment"
                  )}
                </button>
              </div>
            </>
          )}
        </div>
      </div>

      {/* ── Single impurity modal — replaces 12 individual modals ── */}
      <ImpurityModal
        show={impurityModal.open}
        onClose={() => setImpurityModal({ open: false, categoryId: null })}
        category={activeImpurityCategory}
        data={activeImpurityCategory ? categoryData[activeImpurityCategory.id] : null}
        onDeductionChange={(value) =>
          updateCategory(impurityModal.categoryId, "deduction", value)
        }
      />
    </div>
  );
};

export default CalculateTransaction;